import { IAxiosResponseWithError, network } from "@utils/network/network";

export const getContractRequest = async (key: string): Promise<IAxiosResponseWithError<ArrayBuffer>> => {
  return await network.request<ArrayBuffer>("storage", `contract/pdf?key=${key}`, {
    method: "GET",
    responseType: "arraybuffer",
  });
};
